import React, { useState, useEffect } from "react";

export interface SwitchProps {
  checked?: boolean;
  defaultValue?: boolean;
  onCheckedChange?: (checked: boolean) => void;
  label?: string;
}

export const Switch = ({ checked, defaultValue, onCheckedChange, label }: SwitchProps) => {
  // Determine the initial value based on props
  const [isOn, setIsOn] = useState(defaultValue || false);

  // Handle the case when "checked" prop is controlled
  useEffect(() => {
    if (checked !== undefined) {
      setIsOn(checked);
    }
  }, [checked]);

  // Handle the toggle action
  const toggleSwitch = () => {
    if (checked === undefined) {
      // Uncontrolled mode (no "checked" prop passed)
      setIsOn(!isOn);
    }
    if (onCheckedChange) {
      onCheckedChange(!isOn);
    }
  };

  // Inline styles
  const switchStyle = {
    width: "44px",
    height: "24px",
    backgroundColor: isOn ? "rgba(82, 196, 26, 1)" : "rgba(213, 213, 213, 1)",
    borderRadius: "30px",
    position: "relative",
    cursor: "pointer",
    transition: "background-color 0.3s ease",
  } as React.CSSProperties;

  const handleStyle = {
    width: "20px",
    height: "20px",
    backgroundColor: "white",
    borderRadius: "50%",
    position: "absolute",
    top: "2px",
    left: isOn ? "21.5px" : "2.5px",
    transition: "left 0.3s ease",
  } as React.CSSProperties;

  return (
    <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
      {label && (
        <div style={{ display: "flex", alignItems: "center" }}>
          <span style={{ fontSize: 12, color: "#000", lineHeight: "20px" }}>{label}</span>
        </div>
      )}
      <div style={switchStyle} onClick={toggleSwitch}>
        <div style={handleStyle}></div>
      </div>
    </div>
  );
};

export default Switch;
